<template>
 <!-- v-if="detail.joinActivity" -->
    <div class="footer-poup"  v-if="detail.joinActivity">
        {{ isDcsj ? "限时！邀好友，得训练营" : `限时邀请好友减${detail.cutAmount || ""}`}}
    </div>
</template>

<script>
import { hasJoin } from '../../service/api'
export default {
    props: {
        id: Number,
        isDcsj: Boolean
    },
    data() {
        return {
            detail: {}
        }
    },
    mounted() {
        this.hasJoin();
    },
    methods: {
        hasJoin() {
            hasJoin({
                courseId: this.id || 68
            }).then(res => {
                if (res.state == 1) {
                    this.detail = res.content || {}
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.footer-poup {
    position: absolute;
    top: -44px;
    right: 30px;
    width: 280px;
    height: 63px;
    background: url("../../assets/images/footer_poup_icon.png") no-repeat center;
    background-size: 280px 63px;
    line-height: 58px;
    font-size: 24px;
    color: #fff;
    text-align: center;
}
</style>